module.exports = __webpack_public_path__ + "static/img/left2.f12693ff.png";